var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4062 15C57.7812 15 60.4062 17.7188 60.4062 21V51C60.4062 54.375 57.6875 57 54.4062 57H18.4062C15.125 57 12.4062 54.375 12.4062 51V21C12.4062 17.7188 15.125 15 18.4062 15H54.4062ZM22.9062 21C20.4688 21 18.4062 23.0625 18.4062 25.5C18.4062 28.0312 20.2812 30 22.9062 30C25.4375 30 27.4062 28.0312 27.4062 25.5C27.4062 23.0625 25.3438 21 22.9062 21ZM54.3125 50.25C54.5 49.7812 54.5 49.125 54.2188 48.75L42.2188 30.75C41.9375 30.2812 41.4688 30 41 30C40.4375 30 39.9688 30.2812 39.6875 30.75L30.9688 43.875L27.875 39.6562C27.5938 39.2812 27.2188 39 26.75 39C26.1875 39 25.8125 39.2812 25.5312 39.6562L18.9688 48.6562C18.5938 49.125 18.5938 49.6875 18.7812 50.25C19.0625 50.7188 19.5312 51 20.1875 51H53C53.4688 51 54.0312 50.7188 54.3125 50.25Z",
    fill: "#8A97B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImgUpload);
export default __webpack_public_path__ + "static/media/icon-img-upload.63867c6a68cd6e00b58d7ac4ee2e2ecd.svg";
export { ForwardRef as ReactComponent };